import {
  all,
  fork
} from 'redux-saga/effects'

import globalSagas from 'containers/Role/Global/sagas'
import projectSagas from 'containers/Role/Project/sagas'

export default function* (){
  yield all([
    fork(globalSagas),
    fork(projectSagas),
  ])
}
